import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import "../css/ProtectedRoute.css";

export default function ProtectedRoute({
  children,
  requireAdmin     = false,
  requireSuperAdmin = false,
}) {
  const { currentUser, isAdmin, isSuperAdmin, authReady } = useAuth();

  if (!authReady) {
    return (
      <div className="loading-screen">
        <div className="loading-brand">
          <p className="loading-eyebrow">Agape Prime Hotel</p>
          <p className="loading-title">Welcome Back</p>
        </div>
        <div className="spinner-wrap">
          <div className="spinner-outer"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-inner"></div>
        </div>
        <p className="loading-status">Securing your session</p>
      </div>
    );
  }

  if (!currentUser) return <Navigate to="/sign-in" replace />;

  // requireSuperAdmin is stricter than requireAdmin
  if (requireSuperAdmin && !isSuperAdmin) return <Navigate to="/" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />;

  return children;
}
